import { carouselItems } from '@/mocks/home';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20empty%20stage%20with%20fallen%20microphone%2C%20talent%20show%20scandal%20theme%2C%20warm%20crimson%20and%20deep%20amber%20tones%2C%20theatrical%20atmosphere%2C%20intense%20shadows%2C%20editorial%20photography%2C%20dramatic%20mood%20with%20god%20rays&width=1200&height=600&seq=carousel-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Stack%20of%20legal%20contracts%20and%20documents%20on%20dark%20desk%20with%20dramatic%20spotlight%2C%20corporate%20scandal%20investigation%20theme%2C%20warm%20gold%20and%20crimson%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast&width=1200&height=600&seq=carousel-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Broken%20smartphone%20screens%20and%20scattered%20packaging%20on%20dark%20surface%2C%20livestream%20scandal%20aftermath%2C%20warm%20crimson%20glow%2C%20dramatic%20editorial%20lighting%2C%20consumer%20controversy%20theme%2C%20intense%20shadows%2C%20moody%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Film%20director%20chair%20overturned%20on%20empty%20movie%20set%20with%20dramatic%20red%20lighting%2C%20behind%20the%20scenes%20controversy%20theme%2C%20warm%20amber%20and%20crimson%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20photography%2C%20deep%20shadows&width=1200&height=600&seq=carousel-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Sports%20stadium%20at%20night%20with%20dramatic%20spotlight%20and%20empty%20field%2C%20transfer%20scandal%20theme%2C%20warm%20crimson%20and%20gold%20tones%2C%20intense%20atmosphere%2C%20editorial%20photography%2C%20dramatic%20shadows%2C%20mysterious%20mood&width=1200&height=600&seq=carousel-05&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">焦点专题</h2>
          <span className="text-xs text-foreground-500 mt-1">深度调查报道</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={carouselImages[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-primary-500 text-white">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">{item.excerpt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}